import sermorelinInitialQuestions from './initial/questions';
import metabolicSupportFollowupQuestions from './followup/questions';
import tadalafilQuestions from './Tadalafil/questions';

const sermorelinQuestions = [
  ...sermorelinInitialQuestions,
  ...metabolicSupportFollowupQuestions,
  ...tadalafilQuestions
];
export default sermorelinQuestions;

export type { SermorelinFieldAnswers } from './initial/questions';
export type { SermorelinFollowupFieldAnswers } from './followup/questions';

export type {
  MetabolicTadalafilFieldAnswers,
  MetabolicTadalafilFollowupFieldAnswers
} from './Tadalafil/questions';
